export default {
  data() {
    return {
      isRowLoading: false,
    };
  },
  methods: {
    handleRowClick(item, e) {
      if (this.isRowLoading) return;

      this.isRowLoading = true;
      // In domains list, on row click we redirect to domains_show, rather than domains_edit
      const action = ["domains", "phone_numbers"].includes(this.resourceName) ? "show" : "edit";

      const redirectRouteName = this.domainId
        ? { name: `${this.resourceName}_${action}`, params: { id: item.id }, query: { domainId: this.domainId } }
        : { name: `${this.resourceName}_${action}`, params: { id: item.id } };

      if (e.ctrlKey || e.metaKey) {
        window.open(this.$router.resolve(redirectRouteName).href, "_blank");
        this.isRowLoading = false;
      } else {
        return this.$router.push(redirectRouteName).finally(() => {
          this.isRowLoading = false;
        });
      }
    },
  },
};
